import { render, staticRenderFns } from "./addResource.vue?vue&type=template&id=2e509517&scoped=true&"
import script from "./addResource.vue?vue&type=script&lang=js&"
export * from "./addResource.vue?vue&type=script&lang=js&"
import style0 from "./addResource.vue?vue&type=style&index=0&id=2e509517&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e509517",
  null
  
)

export default component.exports